import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const ButtonContainer = styled.button`
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  width: 100%;
  background:#E2E8EC;
  border-radius: 8px;
  margin: 8px 0 8px 0;
  cursor: pointer;
  border:none;
  &:focus {outline:0;}
  @media (max-width:1024px) {
    padding: 8px;
    width: ${props => props.childrenList ? '86%' : '100%'};
  }
  @media (max-width:900px) {
    padding: 8px;
    height: 56px;
    margin: 4px 0 4px 0;
    width: ${props => props.childrenList ? '86%' : '100%'};
  }
`

const ButtonLabel = styled.div`
  width: 100%;
  font-size: 16px;
  font-family: lato;
  @media (max-width:1024px) {
    font-size: 16px;
  }
  @media (max-width:900px) {
    font-size: ${props => props.childrenList ? '1.3em' : '14px'};
  }
`

const ButtonIcon = styled.img`
  width: ${props => props.normal ? '20px' : '30px'};
  height: ${props => props.normal ? '20px' : '30px'};
  margin-right: 1vh;
  @media (max-width:1024px) {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  @media (max-width:900px) {
    width: ${props => props.childrenList ? '36px' : '20px'};
    height: ${props => props.childrenList ? '36px' : '20px'};
    margin-right: 5px;
  }
`

const GoToButton = props => (
  <ButtonContainer onClick={props.onButtonClick} childrenList={props.childrenList}>
    <ButtonIcon normal={props.normal} src={props.icon} childrenList={props.childrenList} />
    <ButtonLabel normal={props.normal} childrenList={props.childrenList}>
      {props.label}
    </ButtonLabel>
    {props.normal ?
      '' :
      <img src="/assets/arrow_icon.svg" alt="go to" />
    }
  </ButtonContainer>
)

GoToButton.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  onButtonClick: PropTypes.func,
  normal: PropTypes.bool,
}

GoToButton.defaultProps = {
  icon: '',
  label: '',
  normal: false,
  onButtonClick: () => {},
}

export default GoToButton



// WEBPACK FOOTER //
// ./src/Components/CustomButtons/GoToButton.jsx